import { Modal } from 'rsuite'

import { TSweepstake, TLuckyNumber, TPrize } from '../types'
import {
  ModalSubtitle,
  TicketBody,
  TicketHoleBottom,
  TicketHoleTop,
  TicketMeta,
  TicketModalContainer,
  TicketNumber,
  TicketPerforation,
  TicketStubs,
  TicketStubText,
  TicketTitle,
} from './style'

type TicketModalProps = {
  numberModalContext: {
    sweepstake: TSweepstake
    luckyNumber: TLuckyNumber
  } | null
  setNumberModalContext: (
    context: { sweepstake: TSweepstake; luckyNumber: TLuckyNumber } | null,
  ) => void
  formatDate: (startDate: Date, endDate: Date) => string
  statusLabels: Record<string, string>
  prize: TPrize | null
}

export function TicketModal({
  numberModalContext,
  setNumberModalContext,
  formatDate,
  statusLabels,
  prize,
}: TicketModalProps) {
  if (!numberModalContext) return null

  const { sweepstake, luckyNumber } = numberModalContext
  const isFinished = sweepstake.status === 'finished'
  const isWinner = luckyNumber.withwin
  const variant = isFinished ? (isWinner ? 'winner' : 'loser') : 'default'

  // Mensagens para o stub lateral
  const stubMessages = {
    winner: `${prize?.name}!`,
    loser: 'Não foi dessa vez',
    default: 'Número da sorte',
  }

  return (
    <Modal
      open={!!numberModalContext}
      onClose={() => setNumberModalContext(null)}
      size="sm"
    >
      <Modal.Header>
        <Modal.Title>
          {isFinished && isWinner ? '🎉 Número Vencedor!' : 'Número da sorte'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TicketModalContainer $variant={variant}>
          <TicketHoleTop />
          <TicketHoleBottom />
          <TicketPerforation />
          <TicketStubs $variant={variant}>
            <TicketStubText $variant={variant}>
              {stubMessages[variant]}
            </TicketStubText>
          </TicketStubs>
          <TicketBody>
            <TicketTitle $variant={variant}>Número da sorte</TicketTitle>
            <TicketNumber $variant={variant}>
              #{luckyNumber.number}
            </TicketNumber>
            {!!prize && isWinner && (
              <>
                <ModalSubtitle style={{ fontWeight: 'bold' }}>
                  Seu prêmio:
                </ModalSubtitle>
                <ModalSubtitle>{prize?.name}</ModalSubtitle>
              </>
            )}

            <TicketMeta $variant={variant}>
              <span>Status: {statusLabels[sweepstake.status]}</span>
              <span>
                Período:{' '}
                {formatDate(
                  new Date(sweepstake.start_at),
                  new Date(sweepstake.end_at),
                )}
              </span>
            </TicketMeta>
          </TicketBody>
        </TicketModalContainer>
      </Modal.Body>
    </Modal>
  )
}
